// extracted by mini-css-extract-plugin
export default {"wrapper":"CheckboxInput_wrapper__f2+JH","circle":"CheckboxInput_circle__ZCwIe"};